import { useState } from "react";
import { useApp } from "../../../context/AppContext";

//import resources
import PulseLoader from "react-spinners/PulseLoader";

//import locales
import { useTranslation } from "react-i18next";
import "../../../i18n";

//import tags
import { toast, Bounce } from 'react-toastify';

//import api
import FetchData from '../../../api/Api';

export default function Profiles() {

    //get user
    const { user, setUser } = useApp();

    //get locale
    const { t } = useTranslation();


    //get data
    const [formData, setFormData] = useState({
        loading: false,
        fname: user?.user?.fname || '',
        lname: user?.user?.lname || '',
        phone: user?.user?.phone || '',
        email: user?.user?.email || '',
        pid: user?.user?.pid || '',
        password: '',
        repeat_password: ''
    });

    const [message, setMessage] = useState(null);

    function inputChange(e) {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value
        }))
    }


    async function handleUpdateUser() {

        if(!localStorage.hasOwnProperty('token')) {
            return;
        }

        setFormData((prevFormData) => ({
            ...prevFormData,
            loading: true
        }))

        try {
            const fetchDataInstance = new FetchData();
            await fetchDataInstance.initHeaders(null, localStorage.getItem('token'));
            const result = await fetchDataInstance.action(`/api/user/${user?.user?.id}/update`, formData, true);
            

            if(result?.status === 'OK') {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    loading: false
                }))

                setUser((prevUser) => ({
                    ...prevUser,
                    user: {
                        ...prevUser.user,
                        fname: formData.fname,
                        lname: formData.lname,
                        phone: formData.phone,
                        pid: formData.pid,
                    },
                }));

                toast.success(t('profile_success'), {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    transition: Bounce,
                });
            }

        } catch (error) {
            if (error.response && error.response.status === 401) {
                setMessage(error.response.data.message || "Unauthorized access.");
            } else {
                setMessage(error.message || "An unexpected error occurred.");
            }

            setFormData((prevFormData) => ({
                ...prevFormData,
                loading: false
            }))
        }
    }


    return (
        <>
            <div className="col-span-12">
                <h2 className="text-2xl font-semibold">{t('profile')}</h2>
            </div>

            <div className='col-span-4'>
                <label htmlFor="fname" className="block text-sm text-gray-700 mb-2">{t('fname')}</label>
                <input value={ formData.fname } onChange={(e)=>inputChange(e)} type="text" id="fname" name="fname" placeholder={t('enter_fname')} className="block w-full h-[52px] rounded-3xl border border-gray-300 px-4 text-sm focus:border-blue-500 focus:ring-blue-500 outline-none" />
            </div>
            <div className='col-span-4'>
                <label htmlFor="lname" className="block text-sm text-gray-700 mb-2">{t('lname')}</label>
                <input value={formData.lname} onChange={(e)=>inputChange(e)} type="text" id="lname" name="lname" placeholder={t('enter_lname')} className="block w-full h-[52px] rounded-3xl border border-gray-300 px-4 text-sm focus:border-blue-500 focus:ring-blue-500 outline-none" />
            </div>
            <div className='col-span-4'>
                <label htmlFor="phone" className="block text-sm text-gray-700 mb-2">{t('phone')}</label>
                <input value={formData.phone} onChange={(e)=>inputChange(e)} type="text" id="phone" name="phone" placeholder={t('enter_phone')} className="block w-full h-[52px] rounded-3xl border border-gray-300 px-4 text-sm focus:border-blue-500 focus:ring-blue-500 outline-none" />
            </div>
            <div className='col-span-4'>
                <label htmlFor="email" className="block text-sm text-gray-700 mb-2">{t('email')}</label>
                <input value={formData.email} disabled onChange={(e)=>inputChange(e)} type="email" id="email" name="email" placeholder={t('enter_email')} className="block w-full h-[52px] rounded-3xl border border-gray-300 px-4 text-sm focus:border-blue-500 focus:ring-blue-500 outline-none" />
            </div>

            
            <div className='col-span-4'>
                <label htmlFor="pid" className="block text-sm text-gray-700 mb-2">{t('pid')}</label>
                <input value={formData.pid} onChange={(e)=>inputChange(e)} type="text" id="pid" name="pid" placeholder={t('enter_pid')} className="block w-full h-[52px] rounded-3xl border border-gray-300 px-4 text-sm focus:border-blue-500 focus:ring-blue-500 outline-none" />
            </div>

            <div className="col-span-12"></div>

            <div className='col-span-6'>
                <label htmlFor="password" className="block text-sm text-gray-700 mb-2">{t('password')}</label>
                <input value={formData.password} onChange={(e)=>inputChange(e)} type="password" id="password" name="password" placeholder={t('enter_password')} className="block w-full h-[52px] rounded-3xl border border-gray-300 px-4 text-sm focus:border-blue-500 focus:ring-blue-500 outline-none" />
            </div>

            <div className='col-span-6'>
                <label htmlFor="repeat_password" className="block text-sm text-gray-700 mb-2">{t('repeat_password')}</label>
                <input value={formData.repeat_password} onChange={(e)=>inputChange(e)} type="password" id="repeat_password" name="repeat_password" placeholder={t('repeat_password')} className="block w-full h-[52px] rounded-3xl border border-gray-300 px-4 text-sm focus:border-blue-500 focus:ring-blue-500 outline-none" />
            </div>
            {
                message ? 
                    <div className='col-span-12 text-[13px] bg-red-100 text-red-700 p-2 rounded-3xl text-center'>{message}</div>
                :
                ''
            }
            <div className='col-span-12'>
                <button onClick={handleUpdateUser} className='bg-[var(--orange)] rounded-3xl px-12 py-3.5 text-white mx-auto block mt-5'>
                    {
                        formData.loading ?
                            <PulseLoader size="8" color="#fff" />
                        :
                        t('update')
                    }
                </button>
            </div>
            
        </>
    );
}